import React, { useState } from 'react';
import { update_broker_client } from '../../utils/actions';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { format } from 'date-fns';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import Select from 'react-select';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import countries from '../../utils/countries.json';
import provinces from '../../utils/provinces.json';

const UpdateBrokerClientModal = ({ showModal, closeModal, producerData }) => {

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { id } = useParams();

  const initialValues = {
    contact_name: producerData ? producerData.contact_name : '',
    contact_email: producerData ? producerData.contact_email : '',
    contact_phone: producerData ? producerData.contact_phone : '',
    contact_address: producerData ? producerData.contact_address : '',
    province: producerData ? producerData.province : '',
    country: producerData ? producerData.country : '',
    history: [],
    commodities: producerData ? producerData.commodities : [],
  };

  const validationSchema = yup.object().shape({
    contact_phone: yup.string().required('Contact Phone Number is required'),
    // commodities: yup.array().min(1, 'Select at least one commodity'),
    contact_address: yup.string().required('Address is required'),
    province: yup.string().required('Province is required'),
    country: yup.string().required('Select Country is required'),
  });

  // Create a useFormik instance with the form configuration
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      try
      {
        const timestamp = new Date();
        const formattedTimestamp = format(timestamp, 'MMMM dd, yyyy hh:mm a');
        const historyStatement = `Updated producer details on ${formattedTimestamp}`;

        const brokerClient = {
          id: producerData.id,
          contact_name: values.contact_name,
          contact_email: values.contact_email,
          contact_phone: values.contact_phone,
          commodities: values.commodities,
          contact_address: values.contact_address,
          province: values.province,
          country: values.country,
          history: [historyStatement],
        };

        setLoading(true);

        setError('');

        await dispatch(update_broker_client(brokerClient));
        setLoading(false);
        closeModal();
        window.location.reload();

      } catch (error)
      {
        setError(error.message);
      } finally
      {
        setLoading(false);
      }
    },
  });

  const options = [
    { value: 'Maize', label: 'Maize' },
    { value: 'Soya Beans', label: 'Soya Beans' },
    { value: 'Wheat', label: 'Wheat' },
    { value: 'Sunflower Seed', label: 'Sunflower Seed' },
    { value: 'cow_peas', label: 'Cow Peas' },
    { value: 'sunflower_cake', label: 'Sunflower Cake' },
    { value: 'gold', label: 'Gold' },
    { value: 'beans', label: 'Beans' },
    { value: 'white_maize', label: 'White Maize' },
    { value: 'yellow_maize', label: 'Yellow Maize' },
  ];

  const handleChange = (selectedOptions) => {
    const selectedValues = selectedOptions.map((option) => option.value);
    formik.setFieldValue('commodities', selectedValues);
  };

  const handlePhoneChange = (phone) => {
    const phoneNumber = parsePhoneNumberFromString(phone);
    const formattedPhoneNumber =
      phoneNumber && phoneNumber.isValid()
        ? phoneNumber.formatInternational()
        : phone;
    formik.handleChange({
      target: {
        name: 'contact_phone',
        value: formattedPhoneNumber,
      },
    });
  };


  return (
    <>
      {showModal ? (
        <div className='fixed inset-0 flex items-center justify-center z-50 overflow-y-auto'>
          <div className='fixed inset-0 bg-black opacity-50'></div>
          <div className='relative p-8 bg-white rounded-lg shadow dark:bg-gray-800 md:p-8 max-h-screen overflow-y-auto'>
            <div class='flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 dark:border-gray-600'>
              <h3 class='text-lg font-semibold text-gray-900 dark:text-white'>
                Update Client
              </h3>
              <button
                type='button'
                onClick={() => closeModal()}
                class='text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white'
                data-modal-toggle='updateProductModal'
              >
                <svg
                  aria-hidden='true'
                  class='w-5 h-5'
                  fill='currentColor'
                  viewBox='0 0 20 20'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    fill-rule='evenodd'
                    d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                    clip-rule='evenodd'
                  ></path>
                </svg>
                <span class='sr-only'>Close</span>
              </button>
            </div>

            <form
              className='space-y-4 md:space-y-6'
              onSubmit={formik.handleSubmit}
            >
              <ol className='items-center w-full sm:w-auto space-y-4 sm:flex sm:space-x-8 sm:space-y-0'>
                <li className='flex items-center text-green-600 dark:text-green-500 space-x-2.5'>
                  <span className='flex items-center justify-center w-8 h-8 border border-green-600 rounded-full shrink-0 dark:border-green-500'>
                    1
                  </span>
                  <span>
                    <h4 className='font-medium leading-tight'>
                      Update Client Form
                    </h4>
                    <p className='text-sm'></p>
                  </span>
                </li>
              </ol>

              <div className='container grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3'>
                <div>
                  <label
                    htmlFor='contact_name'
                    className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                  >
                    Contact Name
                  </label>
                  <input
                    type='text'
                    name='contact_name'
                    value={formik.values.contact_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500'
                    required
                  />
                </div>

                <div>
                  <label
                    htmlFor='contact_phone'
                    className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                  >
                    Contact Phone Number
                  </label>
                  <PhoneInput
                    name='contact_phone'
                    country={'zm'}
                    value={formik.values.contact_phone}
                    onChange={handlePhoneChange}
                    onBlur={formik.handleBlur}
                    containerClass='w-full'
                    buttonClass='dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500'
                  // required
                  >
                    <div className='mb-2'></div>
                  </PhoneInput>
                  {formik.touched.contact_phone &&
                    formik.errors.contact_phone && (
                      <p className='text-red-500 text-xs mt-1'>
                        {formik.errors.contact_phone}
                      </p>
                    )}
                </div>

                <div>
                  <label
                    htmlFor='contact_email'
                    className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                  >
                    Contact Email
                  </label>
                  <input
                    type='email'
                    name='contact_email'
                    value={formik.values.contact_email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500'
                  />

                  {formik.touched.contact_email &&
                    formik.errors.contact_email && (
                      <p className='text-red-500 text-sm mt-1'>
                        {formik.errors.contact_email}
                      </p>
                    )}
                </div>



                <div>
                  <label
                    htmlFor='country'
                    className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                  >
                    Select Country
                  </label>
                  <select
                    name='country'
                    value={formik.values.country}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500'
                  >
                    <option value=''>Choose a country</option>
                    {countries.map((country, index) => (
                      <option key={index} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>
                  {formik.touched.country && formik.errors.country && (
                    <p className='text-red-500 text-sm mt-1'>
                      {formik.errors.country}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor='province'
                    className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                  >
                    Province / State
                  </label>
                  {formik.values.country === 'Zambia' ? (
                    <select
                      name='province'
                      value={formik.values.province}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-500 focus:border-green-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500'
                    >
                      <option value=''>Choose a province</option>
                      {provinces.Zambia.map((province, index) => (
                        <option key={index} value={province}>
                          {province}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type='text'
                      name='province'
                      value={formik.values.province}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className='bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-green-600 focus:border-green-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-green-500 dark:focus:border-green-500'
                    />
                  )}
                  {formik.touched.province && formik.errors.province && (
                    <p className='text-red-500 text-sm mt-1'>
                      {formik.errors.province}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor='profileType'
                    className='block mb-2 text-sm font-medium text-gray-900 dark:text-white'
                  >
                    Select Commodities
                  </label>
                  <Select
                    name='commodities'
                    value={formik.values.commodities.map((value) => ({
                      value,
                      label: value,
                    }))}
                    onChange={handleChange}
                    options={options}
                    isMulti
                  />
                  {/* {formik.touched.commodities && formik.errors.commodities && (
                    <p className='text-red-500 text-sm mt-1'>
                      {formik.errors.commodities}
                    </p>
                  )} */}
                </div>

              </div>

              <div className='flex space-x-4'>
                <button
                  type='button'
                  onClick={closeModal}
                  className='text-gray-900 bg-white hover:bg-gray-100 border border-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-gray-600 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:bg-gray-700 mr-2 mb-2'
                >
                  Close
                </button>
                <button
                  type='submit'
                  disabled={!formik.isValid}
                  className='text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-primary-800 mr-2 mb-2'
                >
                  {formik.isSubmitting
                    ? 'Updating...'
                    : 'Update'}
                </button>
              </div>
              {error && (
                <div
                  className='p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400'
                  role='alert'
                >
                  <span className='font-medium'>Error: </span>
                  {error}
                </div>
              )}
              {loading && (
                <div className='text-center'>
                  <div role='status'>
                    <svg
                      aria-hidden='true'
                      className='inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-green-600'
                      viewBox='0 0 100 101'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
                        fill='currentColor'
                      />
                      <path
                        d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
                        fill='currentFill'
                      />
                    </svg>
                    <span className='sr-only'>Please wait...</span>
                  </div>
                </div>
              )}
            </form>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default UpdateBrokerClientModal;